import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgLightning = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: "100%",
	height: "100%",
	id: "Capa_1",
	style: {
		backgroundColor: "#59a659",
		borderRadius: "50%"
	},
	xmlns: "http://www.w3.org/2000/svg",
	xmlnsXlink: "http://www.w3.org/1999/xlink",
	x: "0px",
	y: "0px",
	viewBox: "0 0 27.964 27.964",
	xmlSpace: "preserve",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("path", {
			style: { fill: "#59a659" },
			d: "M13.982,0.001C6.26,0.001,0,6.261,0,13.981c0,7.724,6.26,13.983,13.982,13.983 c7.725,0,13.982-6.26,13.982-13.983C27.965,6.261,21.707,0.001,13.982,0.001z M13.982,26.533c-6.932,0-12.551-5.62-12.551-12.552 c0-6.93,5.619-12.549,12.551-12.549s12.551,5.62,12.551,12.549C26.533,20.913,20.914,26.533,13.982,26.533z"
		}),
		/* @__PURE__ */ _jsx("polygon", {
			style: { fill: "white" },
			points: "18.781,4.558 8.002,15.279 11.998,15.279 8.926,23.408 19.965,12.689 15.965,12.689"
		})
	]
});
const ForwardRef = forwardRef(SvgLightning);
export default ForwardRef;
